import React, { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Heading } from 'roo-ui/components';
import { FilterContainer } from 'pages/Property/Filters/primitives';
import MultiSelectFilterItem from 'components/Filters/MultiSelectFilter/MultiSelectFilterItem';
import {
  getAvailableClassicRewardCount,
  getAvailableDepositPayCount,
  getAvailableFreeCancellationCount,
  getClassicRewardAvailabilityMessage,
  getDepositPayAvailabilityMessage,
} from 'store/propertyAvailability/propertyAvailabilitySelectors';
import {
  getQueryClassicRewards,
  getQueryDepositPay,
  getQueryFreeCancellation,
} from 'store/propertyAvailability/propertyAvailabilitySelectors/querySelectors';

const PaymentPolicyFilter = ({ onChange }) => {
  const handleChange = useCallback(
    (event) => {
      const { name, checked } = event.target;

      onChange({
        [name]: !!checked,
      });
    },
    [onChange],
  );

  const isClassicRewardsSelected = useSelector(getQueryClassicRewards);
  const isDepositPaySelected = useSelector(getQueryDepositPay);
  const isFreeCancellationSelected = useSelector(getQueryFreeCancellation);
  const classicRewardsAvailabilityMessage = useSelector(getClassicRewardAvailabilityMessage);
  const classicRewardsCount = useSelector(getAvailableClassicRewardCount);
  const depositPayAvailabilityMessage = useSelector(getDepositPayAvailabilityMessage);
  const depositPayCount = useSelector(getAvailableDepositPayCount);
  const freeCancellationCount = useSelector(getAvailableFreeCancellationCount);

  return (
    <Fragment>
      <Heading.h2 display="block" fontSize="sm" mb={2}>
        Payment Options
      </Heading.h2>
      <Box data-testid="payment-policy-filter" mb={[0, 6]}>
        <FilterContainer>
          <MultiSelectFilterItem
            name="Free cancellation"
            type="freeCancellation"
            checked={isFreeCancellationSelected}
            onChange={handleChange}
            count={freeCancellationCount}
            iconName="freeCancellation"
          />
          <MultiSelectFilterItem
            name="Classic Rewards"
            type="classicRewards"
            checked={isClassicRewardsSelected}
            onChange={handleChange}
            count={classicRewardsCount}
            description={classicRewardsAvailabilityMessage}
            iconName="ribbon"
          />
          <MultiSelectFilterItem
            name="Deposit Pay"
            type="depositPay"
            checked={isDepositPaySelected}
            onChange={handleChange}
            count={depositPayCount}
            description={depositPayAvailabilityMessage}
            iconName="depositPay"
          />
        </FilterContainer>
      </Box>
    </Fragment>
  );
};

PaymentPolicyFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default PaymentPolicyFilter;
